import {svgIconWrapper} from '../svg-icon-wrapper';

import TargetArrowRegular from './target-arrow-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TargetArrowRegular {...validProps} />;
}
SvgComponent.iconName = 'targetArrowRegular';

export const TargetArrowRegularIcon = svgIconWrapper(SvgComponent);
